import './App.css';
import { Routes, Route } from "react-router-dom";

// import Project from './routes/projects';
// import Experience from './routes/experience';
import About from "./routes/about";
// import Problem from './routes/problems';
// import CFDSimulation from './routes/cfdsimulation';
// import Geometries from './routes/geometries';
// import Team from './routes/team';
// import Results from './routes/experimentalresults';

import Navbar from './component/navBar';
import Footer from './component/footer';


function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<About />} />
        {/* <Route exact path="/problems" element={<Problem />} />
        <Route exact path="/cfdsimulation" element={<CFDSimulation />} />
        <Route exact path="/geometries" element={<Geometries />} />
        <Route exact path="/team" element={<Team />} />
        <Route exact path="/experimentalresults" element={<Results />} /> */}
      </Routes>
      <Footer />
    </>
  );
}
export default App;
